module.exports = __webpack_public_path__ + "img/upload_picture.38114a7f.svg";